import { useEffect, type FC } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Footer, SEO } from '@coupling/ui';
import Header from '../components/Header';
import { seoConfig } from '../config/seo';
import { analyticsService, AnalyticsEvent } from '../utils/analytics';

export const NotFound: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    analyticsService.logEvent(AnalyticsEvent.PAGE_NOT_FOUND, {
      path: location.pathname,
      referrer: document.referrer || '(direct)',
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO
        title={`Page Not Found - ${seoConfig.siteName}`}
        description="The page you're looking for doesn't exist or has been moved."
        canonical={seoConfig.siteUrl}
        noindex
      />
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-lg mx-auto text-center">
          <h1 className="text-8xl font-display font-bold text-brand-primary mb-4">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-neutral-900 mb-4">
            Page not found
          </h2>
          <p className="text-lg text-neutral-600 mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="mb-8 px-4 py-2 bg-neutral-100 rounded-lg inline-block">
            <code className="text-sm text-neutral-500">{location.pathname}</code>
          </div>

          <div className="mb-8">
            <Button size="lg" onClick={() => navigate('/')}>Go to Homepage</Button>
          </div>

          <div className="flex items-center justify-center gap-6 text-sm">
            <Link to="/about" className="text-brand-primary hover:underline">
              About
            </Link>
            <Link to="/contact" className="text-brand-primary hover:underline">
              Contact
            </Link>
            <Link to="/pricing" className="text-brand-primary hover:underline">
              Pricing
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
